import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Przewija do gory po kazdej zmianie sciezki
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search]);
  return null;
}
